import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Avatar, CircularProgress, Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const WhatsAppProfileModal = ({ open, onClose, whatsappId }) => {
  const [profile, setProfile] = useState({ name: "", status: "", profilePicUrl: "" });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [picFile, setPicFile] = useState(null);

  useEffect(() => {
    if (!open || !whatsappId) return;
    setLoading(true);
    api.get(`/whatsapp/${whatsappId}/profile`)
      .then(({ data }) => setProfile({ name: data.name || "", status: data.status || "", profilePicUrl: data.profilePicUrl || "" }))
      .catch(toastError)
      .finally(() => setLoading(false));
  }, [open, whatsappId]);

  const handleSave = async () => {
    setSaving(true);
    try {
      const formData = new FormData();
      if (profile.name) formData.append("name", profile.name);
      if (profile.status !== undefined) formData.append("status", profile.status);
      if (picFile) formData.append("profilePic", picFile);
      await api.put(`/whatsapp/${whatsappId}/profile`, formData, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Perfil atualizado!");
      onClose();
    } catch (err) { toastError(err); }
    setSaving(false);
  };

  const handleRemovePic = async () => {
    setSaving(true);
    try {
      await api.delete(`/whatsapp/${whatsappId}/profile/pic`);
      setProfile(p => ({ ...p, profilePicUrl: "" }));
      setPicFile(null);
      toast.success("Foto removida!");
    } catch (err) { toastError(err); }
    setSaving(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Editar perfil do WhatsApp</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, pt: "12px !important" }}>
        {loading ? <CircularProgress /> : (
          <>
            <label style={{ cursor: "pointer" }}>
              <Avatar src={picFile ? URL.createObjectURL(picFile) : profile.profilePicUrl} sx={{ width: 80, height: 80, mb: 1 }} />
              <input type="file" accept="image/*" style={{ display: "none" }} onChange={e => setPicFile(e.target.files[0])} />
            </label>
            <Typography variant="caption" color="textSecondary">Clique na foto para alterar</Typography>
            <TextField label="Nome" fullWidth size="small" value={profile.name} onChange={e => setProfile(p => ({ ...p, name: e.target.value }))} />
            <TextField label="Recado (status)" fullWidth size="small" value={profile.status} onChange={e => setProfile(p => ({ ...p, status: e.target.value }))} multiline minRows={2} />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleRemovePic} color="error" disabled={saving || loading || (!profile.profilePicUrl && !picFile)}>
          Remover foto
        </Button>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={saving || loading}>
          {saving ? <CircularProgress size={18} /> : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WhatsAppProfileModal;
